module.exports = __webpack_public_path__ + "static/media/bec.976a1693.jpg";